<template>
<el-card shadow="never" :body-style="{ padding: '20px' }" class="mb-4 mx-auto">
    <div class="mx-auto p-1 text-gray-600">
        <h2 class="text-2xl mb-4">FAQ</h2>
        <div class="mb-4">
            <h3 class="font-bold mb-1">What is Shesfreaky Downloader?</h3>
            <p>
                Shesfreaky Downloader is a free Chrome extension that lets you download videos from Shesfreaky for offline viewing. Save your favorite videos directly to your device in original quality.
            </p>
        </div>

        <div class="mb-4">
            <h3 class="font-bold mb-1">How does Shesfreaky Downloader work?</h3>
            <p>
                The downloader works through a Chrome extension that extracts video URLs from Shesfreaky pages. Paste the video URL into the downloader, and it will find and prepare the video for download.
            </p>
        </div>

        <div class="mb-4">
            <h3 class="font-bold mb-1">Is Shesfreaky Downloader safe to use?</h3>
            <p>
                Yes, Shesfreaky Downloader is safe to use. It runs entirely in your Chrome browser as an extension, without requiring any desktop software installation that could harm your computer.
            </p>
        </div>

        <div>
            <h3 class="font-bold mb-1">Can I download videos on mobile devices?</h3>
            <p>
                Shesfreaky Downloader is designed for desktop Chrome browsers. For mobile downloads, you would need to use the desktop Chrome browser or transfer downloaded files from your computer to your mobile device.
            </p>
        </div>
    </div>
</el-card>
</template>

<script>
export default {

}
</script>

<style>

</style>
